export default __webpack_public_path__ + "locales/sq-AL/PreparationPortal.json?hash=2f64a87467c30fe0959f5b658537036d";